import {
  HomefieldIconChevronDown,
  HomefieldIconChevronUp,
  HomefieldIconPlChevronDown,
  HomefieldIconPlChevronUp,
} from '@dsg-tech/homefield-react-icons';
import { checkStores, setDataEmTag } from 'utility/utility';

import React from 'react';

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-static-element-interactions */

interface AccordionProps {
  openAccordion: boolean;
  accordionCatData: {
    n: string;
    u: string;
    ch?: { n: string; u: string }[];
  };
  accordionIndex: number;
  accordionClickHandler: (index: number, data: any) => void;
  accordionKeyEventHandler: (index: number, data: any, event: React.KeyboardEvent) => void;
  dataEmCatTitle: string;
  storeIdentifierName: string;
}

export default function Accordion({
  openAccordion,
  accordionCatData,
  accordionIndex,
  accordionClickHandler,
  accordionKeyEventHandler,
  dataEmCatTitle,
  storeIdentifierName,
}: Readonly<AccordionProps>) {
  function createAriaLabel() {
    if (accordionCatData.n && accordionCatData.ch) {
      return `${openAccordion ? 'Open' : 'Close'} ${accordionCatData.n} Accordion`;
    }

    return `${openAccordion ? 'Open' : 'Close'} Accordion`;
  }

  const chevronDownIcon =
    storeIdentifierName === 'dsg' ? (
      <HomefieldIconChevronDown height="24px" width="24px" />
    ) : (
      <HomefieldIconPlChevronDown height="10px" width="10px" />
    );

  const chevronUpIcon =
    storeIdentifierName === 'dsg' ? (
      <HomefieldIconChevronUp height="24px" width="24px" />
    ) : (
      <HomefieldIconPlChevronUp height="10px" width="10px" />
    );

  return (
    <div className="accordion-container">
      <div className="accordion-container__accordion">
        {(accordionCatData?.ch?.length ?? 0) > 0 ? (
          <button
            tabIndex={0}
            type="button"
            id={`accordion-item-${accordionIndex}`}
            aria-expanded={openAccordion}
            aria-label={createAriaLabel()}
            data-em={setDataEmTag('TopNav', dataEmCatTitle, accordionCatData.n)}
            className={`accordion-container__accordion--category hmf-body-bold-l hmf-px-s hmf-py-m ${
              openAccordion ? 'accordion-box-shadow' : ''
            }`}
            onClick={() => accordionClickHandler(accordionIndex, accordionCatData)}
            onKeyDown={(e) => accordionKeyEventHandler(accordionIndex, accordionCatData, e)}>
            <p className="ptitle hmf-my-0">{accordionCatData.n}</p>
            {accordionCatData.ch &&
              (!openAccordion ? (
                chevronDownIcon
              ) : (
                <>
                  <span className="flag" />
                  {chevronUpIcon}
                </>
              ))}
          </button>
        ) : (
          <a
            tabIndex={0}
            id={`accordion-item-${accordionIndex}`}
            aria-expanded={openAccordion}
            aria-label={createAriaLabel()}
            data-em={setDataEmTag('TopNav', dataEmCatTitle, accordionCatData.n)}
            className={`accordion-container__accordion--category hmf-body-bold-l hmf-px-s hmf-py-m ${
              openAccordion ? 'accordion-box-shadow' : ''
            }`}
            onClick={() => accordionClickHandler(accordionIndex, accordionCatData)}
            onKeyDown={(e) => accordionKeyEventHandler(accordionIndex, accordionCatData, e)}
            href={checkStores(accordionCatData.u)}>
            <p className="ptitle hmf-my-0">{accordionCatData.n}</p>
          </a>
        )}
        <div
          aria-labelledby={`accordion-${accordionIndex}`}
          aria-hidden={!openAccordion}
          className={`accordion-container__accordion--sublink-container ${
            !openAccordion ? 'hmf-display-none' : 'hmf-display-flex'
          }`}>
          {accordionCatData.ch &&
            accordionCatData.ch.length > 0 &&
            accordionCatData.ch.map((category: any) => (
              <a
                key={`category-${category.n}`}
                tabIndex={0}
                data-em={setDataEmTag('TopNav', dataEmCatTitle, accordionCatData.n, category.n)}
                className="accordion-container__accordion--sublinks hmf-body-m hmf-p-m"
                href={checkStores(category.u)}>
                {category.n}
              </a>
            ))}
        </div>
      </div>
    </div>
  );
}
